import { PreferencesCookiesKey, defaultCookiePreferences } from '@/constants/preferences'
import { storage } from '@/lib/storage'

const FONT_SCALE_CSS_VAR = '--app-font-scale'
const FONT_SCALE_KEY = `${PreferencesCookiesKey.FONT_SCALE}`
const PDF_FONT_SCALE_KEY = `${PreferencesCookiesKey.PDF_FONT_SCALE}`

const parseFontScale = (value: string | null): number => {
  const fallback = defaultCookiePreferences[PreferencesCookiesKey.FONT_SCALE].default
  if (!value) return fallback

  const parsed = Number(value)
  if (Number.isNaN(parsed)) return fallback

  return Math.min(1.4, Math.max(1, parsed))
}

export const getSavedFontScale = (): number => parseFontScale(storage.get(FONT_SCALE_KEY))

export const applyFontScale = (scale: number): void => {
  if (typeof document === 'undefined') return
  document.documentElement.style.setProperty(FONT_SCALE_CSS_VAR, String(scale))
}

export const initializeFontScale = (): number => {
  const scale = getSavedFontScale()
  applyFontScale(scale)
  return scale
}

export const setFontScale = (scale: number): number => {
  const normalized = Math.min(1.4, Math.max(1, scale))
  storage.set(FONT_SCALE_KEY, String(normalized))
  applyFontScale(normalized)
  return normalized
}

export const getSavedPdfFontScale = (): number => parseFontScale(storage.get(PDF_FONT_SCALE_KEY))

export const setPdfFontScale = (scale: number): number => {
  const normalized = Math.min(1.4, Math.max(1, scale))
  storage.set(PDF_FONT_SCALE_KEY, String(normalized))
  return normalized
}
